<template lang="pug">
.wrap
  page-title Edit user

  el-row(:gutter="40")
    el-col(:lg="10")
      user-form(v-if='companyUser' :user='companyUser.user' ref='userForm' :showPassword='false' :edit='true')

      .actions
        el-button(type='primary' @click="submitForm") Save changes
        el-button(type='danger' @click="confirmDelete") Delete

      .change-password-panel
        h3.panel-title Change password
        change-user-password-form(:change-password='changePassword' ref='changePasswordForm')

      .actions
        el-button(type='primary' @click="submitChangePasswordForm") Change password

    el-col(:lg="14")
      h3.assign-seat-title Assign seats
      seats-assigner(v-if='!loading' v-model='appLicenseGroupIds' ref='seatsAsssigner')

</template>

<script>
import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import UserForm from "@/shared/components/UserForm";
import ChangeUserPasswordForm from "@/shared/components/ChangeUserPasswordForm";
import SeatsAssigner from "@/shared/components/SeatsAssigner";
import CrudMixin from "@/shared/mixins/Crud";

export default {
  mixins: [CrudMixin],
  components: { PageTitle, UserForm, SeatsAssigner, ChangeUserPasswordForm },
  data() {
    return {
      companyUser: null,
      appLicenseGroupIds: [],
      loading: true,
      changePassword: {
        newPassword: "",
        confirmPassword: "",
        notify: true
      }
    };
  },
  computed: {
    companyUserId() {
      return this.companyUser && this.companyUser.id;
    }
  },
  methods: {
    ...mapActions("companyUsers", [
      "fetchCompanyUser",
      "updateCompanyUser",
      "deleteCompanyUser"
    ]),
    ...mapActions("users", ["changeUserPassword"]),
    loadInitialData() {
      this.loading = true;
      this.wrapLoadAction(this.fetchCompanyUser)({
        id: this.$route.params.userId
      }).then(data => {
        this.companyUser = {
          ...data,
          user: {
            ...data.user,
            isCompanyAdmin: data.isCompanyAdmin, // TODO: this is a bit messy here, update the UserForm when possible
            isActive: data.isActive // See above
          }
        };
        this.appLicenseGroupIds = data.user.appLicenseGroupUsers.map(
          g => g.appLicenseGroup.id
        );
        this.loading = false;
      });
    },
    submitForm() {
      this.$refs.userForm.validate(valid => {
        if (!valid) {
          this.$notify({
            title: "Error",
            message: "Please fix the validation errors",
            type: "error"
          });
          return;
        }
        const data = {
          ...this.companyUser,
          isCompanyAdmin: this.companyUser.user.isCompanyAdmin,
          isActive: this.companyUser.user.isActive,
          appLicenseGroupIds: this.appLicenseGroupIds
        };
        this.wrapApiAction(this.updateCompanyUser)({ data }).then(() => {
          this.$refs.seatsAsssigner.loadData();
          this.loadInitialData();
        });
      });
    },
    submitChangePasswordForm() {
      this.$refs.changePasswordForm.validate(valid => {
        if (!valid) {
          this.$notify({
            title: "Error",
            message: "Please fix the validation errors",
            type: "error"
          });
          return;
        }
        const data = {
          companyUser: this.companyUserId,
          newPassword: this.changePassword.newPassword,
          notify: this.changePassword.notify
        };
        this.wrapApiAction(this.changeUserPassword)({ data }).then(() => {
          this.changePassword = {
            newPassword: "",
            confirmPassword: "",
            notify: true
          };
          this.$refs.changePasswordForm.resetFields();
        });
      });
    },
    confirmDelete() {
      this.$confirm(
        "This will permanently delete the user. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      ).then(() => {
        this.deleteCompanyUser({ id: this.companyUser.id }).then(() => {
          this.$message({ type: "info", message: "User deleted" });
          this.$router.push({ name: "companyAdmin:users" });
        });
      });
    }
  },
  created() {
    this.loadInitialData();
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/mixins.scss";
.assign-seat-title {
  font-family: "gilroyextrabold";
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 0.05em;
  font-size: 14px;
  color: #2c3e50;
  margin: 0 0 15px 0;
  @include MQ(LLG) {
    margin: 15px 0;
  }
}

.actions {
  margin-top: 20px;
}

.change-password-panel {
  margin-top: 30px;
}

.panel-title {
  margin-bottom: 10px;
  font-size: 28px;
  font-family: "gilroylight";
  font-weight: 400;
  margin: 60px 0px 20px 0px;
}
</style>
